import React, { memo } from 'react';
import classNames from 'classnames';
import cls from '../Calculations.module.css';
import { Input } from '../../../../../../components/newUI/Input/Input';

export const Windows = memo(
    ({ isManualCalculations, onInput, calculations, manualCalculations }) => {
        return (
            <div className={classNames(cls)}>
                <h3 className={cls.subBlockHeader}>{i18next.t('Windows.return.subBlockHeader')}</h3>
                <div className={cls.columns}>
                    <Input
                        type={'measurements'}
                        inputName={'window_quantity'}
                        onChange={onInput}
                        value={
                            (!isManualCalculations ? calculations : manualCalculations)
                                .window_quantity
                        }
                        classes={cls.column}
                        placeholder={0}
                        label={i18next.t('Windows.return.input.windowQuantityLabel')}
                        isDisabled={!isManualCalculations}
                    />
                    <Input
                        type={'measurements'}
                        inputName={'window_area'}
                        onChange={onInput}
                        value={
                            (!isManualCalculations ? calculations : manualCalculations).window_area
                        }
                        classes={cls.column}
                        placeholder={0}
                        label={i18next.t('Windows.return.input.windowAreaLabel')}
                        isDisabled={!isManualCalculations}
                    />
                    <Input
                        type={'measurements'}
                        inputName={'window_perimeter'}
                        onChange={onInput}
                        value={
                            (!isManualCalculations ? calculations : manualCalculations)
                                .window_perimeter
                        }
                        classes={cls.column}
                        placeholder={0}
                        label={i18next.t('Windows.return.input.windowPerimeterLabel')}
                        isDisabled={!isManualCalculations}
                    />
                </div>
                <div className={cls.columns}>
                    <Input
                        type={'measurements'}
                        inputName={'window_slope_area'}
                        onChange={onInput}
                        value={
                            (!isManualCalculations ? calculations : manualCalculations)
                                .window_slope_area
                        }
                        classes={cls.column}
                        placeholder={0}
                        label={i18next.t('Windows.return.input.windowSlopeAreaLabel')}
                        isDisabled={!isManualCalculations}
                    />
                    <Input
                        type={'measurements'}
                        inputName={'window_slope_perimeter'}
                        onChange={onInput}
                        value={
                            (!isManualCalculations ? calculations : manualCalculations)
                                .window_slope_perimeter
                        }
                        classes={cls.column}
                        placeholder={0}
                        label={i18next.t('Windows.return.input.windowSlopePerimeterLabel')}
                        isDisabled={!isManualCalculations}
                    />
                </div>
            </div>
        );
    }
);
